export enum PhotogenyRejectionReasonEnum {
  NO_PROFILE = "NO_PROFILE",
  CRIED_TOO_MUCH = "CRIED_A_LOT",
  MOVES_TOO_MUCH = "MOVES_A_LOT",
}

export const PhotogenyRejectionReasonTranslate: Record<PhotogenyRejectionReasonEnum, string> = {
  [PhotogenyRejectionReasonEnum.NO_PROFILE]: "Sem perfil",
  [PhotogenyRejectionReasonEnum.CRIED_TOO_MUCH]: "Chorou muito",
  [PhotogenyRejectionReasonEnum.MOVES_TOO_MUCH]: "Se movimenta muito",
};
